const e = {
  bg: "cardOverlay",
  "&:focus-visible": (a) => ({
    ...a.outline({ color: "primary" })
  }),
  ":hover": {
    bg: "lightGray3"
  },
  '&[data-state="checked"]:hover': {
    bg: "black"
  },
  ":disabled": {
    bg: "lightGray3"
  }
};
export {
  e as radioButtonStyles
};
